"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var TypographyWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-weight: ", ";\n  h1,\n  .h1,\n  h2,\n  .h2,\n  h3,\n  .h3,\n  h4,\n  .h4,\n  h5,\n  .h5,\n  h6,\n  .h6 {\n    line-height: 100%;\n    font-weight: ", ";\n  }\n  h1,\n  .h1 {\n    font-size: 2rem;\n  }\n  h2,\n  .h2 {\n    font-size: 1.75rem;\n  }\n  h3,\n  .h3 {\n    font-size: 1.5rem;\n  }\n  h4,\n  .h4 {\n    font-size: 1.25rem;\n  }\n  h5,\n  .h5 {\n    font-size: 1rem;\n  }\n  h6,\n  .h6 {\n    font-size: 0.75rem;\n  }\n  p,\n  .p {\n    font-size: 1rem;\n    line-height: 180%;\n  }\n  caption,\n  .caption {\n    font-size: 0.75rem;\n    font-weight: normal;\n  }\n  button,\n  .button {\n    font-size: 1rem;\n    font-weight: bold;\n  }\n"], ["\n  display: ", ";\n  font-weight: ", ";\n  h1,\n  .h1,\n  h2,\n  .h2,\n  h3,\n  .h3,\n  h4,\n  .h4,\n  h5,\n  .h5,\n  h6,\n  .h6 {\n    line-height: 100%;\n    font-weight: ", ";\n  }\n  h1,\n  .h1 {\n    font-size: 2rem;\n  }\n  h2,\n  .h2 {\n    font-size: 1.75rem;\n  }\n  h3,\n  .h3 {\n    font-size: 1.5rem;\n  }\n  h4,\n  .h4 {\n    font-size: 1.25rem;\n  }\n  h5,\n  .h5 {\n    font-size: 1rem;\n  }\n  h6,\n  .h6 {\n    font-size: 0.75rem;\n  }\n  p,\n  .p {\n    font-size: 1rem;\n    line-height: 180%;\n  }\n  caption,\n  .caption {\n    font-size: 0.75rem;\n    font-weight: normal;\n  }\n  button,\n  .button {\n    font-size: 1rem;\n    font-weight: bold;\n  }\n"])), function (_a) {
    var display = _a.display;
    return display || 'inherit';
}, function (_a) {
    var weight = _a.weight;
    return (weight === 'heavy' ? 600 : weight);
}, function (_a) {
    var weight = _a.weight;
    return (weight === 'heavy' ? 600 : weight);
});
var StyledTagComponent = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  display: ", ";\n  margin-top: 0;\n  margin-bottom: ", ";\n  white-space: ", ";\n  overflow: ", ";\n  text-overflow: ellipsis;\n  text-align: ", ";\n  text-transform: ", ";\n"], ["\n  color: ", ";\n  display: ", ";\n  margin-top: 0;\n  margin-bottom: ", ";\n  white-space: ", ";\n  overflow: ", ";\n  text-overflow: ellipsis;\n  text-align: ", ";\n  text-transform: ", ";\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.text;
}, function (_a) {
    var display = _a.display;
    return display || 'inherit';
}, function (_a) {
    var paragraph = _a.paragraph;
    return (paragraph ? '1rem' : '0');
}, function (_a) {
    var truncate = _a.truncate;
    return (truncate ? 'nowrap' : 'initial');
}, function (_a) {
    var truncate = _a.truncate;
    return (truncate ? 'hidden' : 'visible');
}, function (_a) {
    var align = _a.align;
    return align || 'inherit';
}, function (_a) {
    var textTransform = _a.textTransform;
    return textTransform || 'none';
});
var Typography = function (_a) {
    var children = _a.children, _b = _a.tag, tag = _b === void 0 ? 'p' : _b, _c = _a.variant, variant = _c === void 0 ? 'p' : _c, _d = _a.display, display = _d === void 0 ? 'block' : _d, _e = _a.weight, weight = _e === void 0 ? 'normal' : _e, rest = __rest(_a, ["children", "tag", "variant", "display", "weight"]);
    return (react_1.default.createElement(TypographyWrapper, { display: display, weight: weight },
        react_1.default.createElement(StyledTagComponent, __assign({ as: tag, className: variant }, rest), children)));
};
exports.default = Typography;
var templateObject_1, templateObject_2;
